<template>
  <div id="app">
    <!--登入动画-->
    <transition enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut">
      <router-view class="app-router-view"></router-view>
    </transition>
    <loading :text="loading.message"
             v-show="loading.show" />
  </div>
</template>

<script>
import 'animate.css'
import loading from '@/components/loading/loading.vue'
export default {
  name: 'App',
  data () {
    return {
      loading: {
        show: false,
        message: ''
      }
    }
  },
  created () {
    window.$app = this
  },
  mounted () {
    this.$on('loading', message => {
      this.loading.show = (message !== null)
      this.loading.message = message
    })
  },
  components: { loading }
}
</script>

<style rel="stylesheet/scss" lang="scss">
html,
body {
  width: 100%;
  height: 100%;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  background: #f5f5f5;
  font-size: 28px;
  width: 100%;
  height: 100%;
  .app-router-view {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
    backface-visibility: hidden;
    transform: translate3d(0, 0, 0);
    transform-style: preserve-3d;
    visibility: visible;
    .banner {
      width: 100%;
      height: 290px;
      object-fit: cover;
      img {
        height: 290px;
        width: 100%;
      }
    }
    .btn {
      width: 247px;
      height: 60px;
      background: #ffa900;
      border-radius: 30px;
      text-align: center;
      line-height: 64px;
      color: #ffffff;
      font-size: 28px;
      font-weight: 500;
    }
    .self-btm {
      align-self: flex-end;
    }
    .notify-info {
      font-size: 24px;
    }
    .flex {
      display: flex;
    }
    .flex-justify {
      justify-content: space-between;
    }
    .flex-justify2 {
      justify-content: space-around;
    }
    .justify-center {
      justify-content: center;
    }
    .flex-align {
      align-items: center;
    }
    .flex-column {
      display: flex;
      flex-direction: column;
    }
    .flex-average {
      flex: 1;
    }
    .fixed-btm {
      position: fixed;
      left: 0;
      bottom: 0;
    }
    .panel-padding {
      padding: 15px 30px;
    }
    .cell-padding {
      padding: 15px 0;
    }
    .moneyColor {
      color: #f84343;
    }
    .breakfast {
      background: #3aa4fc;
    }
    .lunch {
      background: #00c3ac;
    }
    .dinner {
      background: #f59d27;
    }
    .lunch-color {
      color: #00c3ac;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue